import React, { Component } from "react";
import $ from "jquery";
import toast from "../helpers/toast";
import PatientHeader from "../patient/Patientheader";
import PatientSideMenu from "../patient/Patientsidemenu";
import * as SecureLS from "secure-ls";
import Httpconfig from "../helpers/Httpconfig";
import Constant from "../../constants";
import Chart from 'chart.js/auto';
var ls = new SecureLS({
  encodingType: "aes",
  encryptionSecret: "medleymed",
});
const moment = require("moment");



export default class Vitalsheethistory extends Component {
  constructor(props) {

    super(props);
    this.chartRefBloodPressure = React.createRef();
    this.chartRefTemperature = React.createRef();
    this.chartRefPulse = React.createRef();
    this.chartRefBloodSugar = React.createRef();
    this.chartRefRespiratoryRate = React.createRef();
    this.chartRefHeartRate = React.createRef();
    this.chartRefHeadCircumference = React.createRef();
    this.chartRefSpo2 = React.createRef();
    this.chartRefSteps = React.createRef();
    this.chartRefHeight = React.createRef();
    this.chartRefWeight = React.createRef();
    this.chartRefBmi = React.createRef();
    this.chartRefPainRatingScale = React.createRef();


    this.state = {
      patientId: "",
      vitalInfo: "",
      patientRelatives: [],
      selectedRelativeId: 0,
      selectedDate: moment().format("YYYY-MM-DD"),
      timeBarPoints: [],
      selectedPtientVitalArray: [],
      count: 0,
      nodata: "No Data Found",
      name: "All Vitals",
    };

  }

  // To get detais after first render
  componentDidMount = () => {
    console.log("selectedDate...", this.state.selectedDate)
    var retrievedObject = ls.get("userObjEnc");
    if (retrievedObject) {
      this.state.patientId = retrievedObject.patient_id
      this.state.selectedRelativeId = retrievedObject.patient_id
      // this.getPatientVitals();
      this.getPatientRelatives();

    } else {
      window.location.href = "/login";
    }


  }

  // Blood Pressure View Graph

  getBloodPresssure = () => {
    var data = [];
    var data1 = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    var linegraph = "";
    var linegraphStatus = true;
    key = 'blood_pressure_diastolic';
    key1 = 'blood_pressure_systolic';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key]) {
        data.push(element[key])
      }
      if (element[key1]) {
        data1.push(element[key1])
      }
      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefBloodPressure.current.getContext("2d");
    if (typeof this.linegraphBloodPressure !== 'undefined') {
      this.linegraphBloodPressure.destroy();
    }
    this.linegraphBloodPressure = new Chart(ctx, {
      type: "line",
      dragData: true,
      
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Blood Pressure (mmHg)'
          },
          
        },
        maintainAspectRatio: true,
        
      },
      data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data1,
            label: key1 +" (mmHg)",
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
          {
            data: data,//[86,114,106,106,107,111,133],
            label: key +" (mmHg)",
            borderColor: "#3e95cd",
            backgroundColor: "#7bb6dd",
            fill: false,

          }
          // }, { 
          // 	data: [10,21,60,44,17,21,17],
          // 	label: "Pending",
          // 	borderColor: "#ffa500",
          // 	backgroundColor:"#ffc04d",
          // 	fill: false,
          // }, { 
          // 	data: [6,3,2,2,7,0,16],
          // 	label: "Rejected",
          // 	borderColor: "#c45850",
          // 	backgroundColor:"#d78f89",
          // 	fill: false,
          // }
        ]
      },

    });
    this.setState({ count: this.state.count + 1 });
  }


  // Height View Graph
  getHeight = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'height';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefHeight.current.getContext("2d");
    if (typeof this.linegraphHeight !== 'undefined') {
      this.linegraphHeight.destroy();
    }

    this.linegraphHeight = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Height (cms)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      },
      data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1,
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });

  }

  // Weight View Graph
  getWeight = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'weight';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefWeight.current.getContext("2d");
    if (typeof this.linegraphWeight !== 'undefined') {
      this.linegraphWeight.destroy();
    }

    this.linegraphWeight = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Weight (kg) '
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1,
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });

  }

  // BMI View Graph
  getBMI = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'bmi';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefBmi.current.getContext("2d");
    if (typeof this.linegraphBmi !== 'undefined') {
      this.linegraphBmi.destroy();
    }

    this.linegraphBmi = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'BMI (kg/m2)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1,
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });

  }

  // Temperature View Graph
  getTemperature = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'temperature';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefTemperature.current.getContext("2d");
    if (typeof this.linegraphTemperature !== 'undefined') {
      this.linegraphTemperature.destroy();
    }

    this.linegraphTemperature = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Temperature (°F)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1,
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });

  }

  // Pulse View Graph
  getPulse = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'pulse_rate ';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefPulse.current.getContext("2d");
    if (typeof this.linegraphPulse !== 'undefined') {
      this.linegraphPulse.destroy();
    }

    this.linegraphPulse = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Pulse (breaths per minute)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1 +" (breaths per minute)",
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });

  }

  // Blood Sugar View Graph
  getBloodSugar = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'blood_sugar';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefBloodSugar.current.getContext("2d");
    if (typeof this.linegraphBloodSugar !== 'undefined') {
      this.linegraphBloodSugar.destroy();
    }

    this.linegraphBloodSugar = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Blood Sugar (mg/dL)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1 +" (mg/dL)",
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });

  }

  // Resporatory Rate View Graph
  getResporatoryRate = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'respiratory_rate';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefRespiratoryRate.current.getContext("2d");
    if (typeof this.linegraphRespiratoryRate !== 'undefined') {
      this.linegraphRespiratoryRate.destroy();
    }

    this.linegraphRespiratoryRate = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Respiratory Rate (breaths per minute)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1 + " (breaths per minute)",
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });

  }

  // Heart Rate View Graph
  getHeartRate = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'fetal_heart_rate';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefHeartRate.current.getContext("2d");
    if (typeof this.linegraphHeartRate !== 'undefined') {
      this.linegraphHeartRate.destroy();
    }

    this.linegraphHeartRate = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Heart Rate (/mi)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1 +"( /mi)",
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });


  }

  // Head circumference View Graph
  getHeadCircumference = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'head_circumference';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefHeadCircumference.current.getContext("2d");
    if (typeof this.linegraphHeadCircumference !== 'undefined') {
      this.linegraphHeadCircumference.destroy();
    }

    this.linegraphHeadCircumference = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Head Circumference (cm)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1 + "(cm)",
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });


  }

  // GetSpo2 View Graph
  getSpo2 = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'spo2';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefSpo2.current.getContext("2d");
    if (typeof this.linegraphSpo2 !== 'undefined') {
      this.linegraphSpo2.destroy();
    }
    if (data.length > 0) {
      this.linegraphSpo2 = new Chart(ctx, {
        type: "line",
        dragData: true,
        options: {
          responsive: true,
          plugins: {
            legend: {
              position: 'bottom',
            },
            title: {
              display: true,
              text: 'Sp02 (%)'
            }
          },
          maintainAspectRatio: false,
          // indexAxis: 'y',
          // scales: {
          //   x: {
          //     beginAtZero: true
          //   }
          // }
        }, data: {
          labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
          datasets: [
            {
              data: data,//[70,90,44,60,83,90,100],
              label: key1 +" (%)",
              borderColor: "#3cba9f",
              backgroundColor: "#71d1bd",
              fill: false,
            },
          ]
        },

      });
    }

  }

  // Steps View Graph
  getSteps = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'steps';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefSteps.current.getContext("2d");
    if (typeof this.linegraphSteps !== 'undefined') {
      this.linegraphSteps.destroy();
    }

    //if (Object.keys(data).length > 0) {
    this.linegraphSteps = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Steps (/Day)'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1 + "( /Day)",
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });
  }

  // Pain Rating scale View Graph
  getPainRatingScale = () => {
    var data = [];
    var dates = [];
    var key = "";
    var key1 = "";
    var key2 = "";
    key1 = 'pain_rating_scale';
    key2 = 'createdAt';

    let modifiedArr = this.state.selectedPtientVitalArray.map(function (element) {
      if (element[key1]) {
        data.push(element[key1])
      }

      if (element[key2]) {
        dates.push(moment(element[key2]).format("MMM Do YY  hh:mm :A"),)

      }
    });

    var ctx = this.chartRefPainRatingScale.current.getContext("2d");
    if (typeof this.linegraphPainRatingScale !== 'undefined') {
      this.linegraphPainRatingScale.destroy();
    }

    //if (Object.keys(data).length > 0) {
    this.linegraphPainRatingScale = new Chart(ctx, {
      type: "line",
      dragData: true,
      options: {
        responsive: true,
        plugins: {
          legend: {
            position: 'bottom',
          },
          title: {
            display: true,
            text: 'Pain Rating Scale'
          }
        },
        maintainAspectRatio: false,
        // indexAxis: 'y',
        // scales: {
        //   x: {
        //     beginAtZero: true
        //   }
        // }
      }, data: {
        labels: dates, //["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        datasets: [
          {
            data: data,//[70,90,44,60,83,90,100],
            label: key1,
            borderColor: "#3cba9f",
            backgroundColor: "#71d1bd",
            fill: false,
          },
        ]
      },

    });
  }

  //To get Patient Vitals
  getPatientVitals = () => {

    let sdate = this.state.selectedSDate ? this.state.selectedSDate.split("T")[0] : "";
    let edate = this.state.selectedSDate ? this.state.selectedEDate.split("T")[0] : "";
    if (!sdate && !edate) {
      sdate = this.state.selectedSDate;
      edate = this.state.selectedEDate;
    }
    if (new Date(sdate) > new Date(edate)) {
      toast.error("Start date can't be grater then end data")
      return
    }
    Httpconfig.httptokenpost(
      Constant.siteurl + "api/VitalInformation/getPatientVitalsByDate", {
      patientId: this.state.selectedRelativeId,
      startdate: sdate,
      enddate: edate
    }
    ).then((response) => {
      this.state.selectedPtientVitalArray = response.data.data.map((item) => {
        let realFeet = ((item.height * 0.393700) / 12);
        let feet = Math.floor(realFeet);
        let inches = Math.round((realFeet - feet) * 12);
        let feetInches = feet + "'" + inches
        item.feetInches = feetInches
        return item
      })
      this.state.vitalInfo = this.state.selectedPtientVitalArray[0]
      if (!this.state.vitalInfo) this.state.vitalInfo = { patient_type: "adult" }
      this.state.selectedDate = this.state.vitalInfo ? this.state.vitalInfo.createdAt : this.state.selectedDate
      if (Object.keys(response.data.data).length > 0) {
        this.setState({
          nodata: ""
        })
        this.timeBarPointsRendering()
        this.getBloodPresssure();
        this.getHeight();
        this.getWeight();
        this.getBMI();
        this.getTemperature();
        this.getPulse();
        this.getBloodSugar();
        this.getResporatoryRate();
        this.getHeartRate();
        this.getHeadCircumference();
        this.getSpo2();
        this.getSteps();
        this.getPainRatingScale();
      } else {
        toast.error("No Records Found")
      }

    })
  }

  //Filter vital info based on the time seleted in time bar
  vitalTimeFilter = (vitalId) => {
    let selctedTimeData = this.state.selectedPtientVitalArray.filter((vital) => {
      return vital.id == vitalId
    })
    this.state.vitalInfo = selctedTimeData[0]
    this.state.selectedDate = this.state.vitalInfo.createdAt
    this.timeBarPointsRendering()
  }

  //To render html time bar 
  timeBarPointsRendering = () => {
    this.state.timeBarPoints = this.state.selectedPtientVitalArray.map((vaital) => {
      return (<div class={this.state.vitalInfo.id == vaital.id ? "stepwizard-step active" : "stepwizard-step"} id={vaital.createdAt}
        onClick={() => { this.vitalTimeFilter(vaital.id) }}>
        <a type="button" class="btn btn-default btn-circle"></a>
        <p>{moment(vaital.createdAt).format("HH:mm A")}</p>
      </div>)
    })
    this.forceUpdate()
  }

  //To get Patient relatives info
  getPatientRelatives = () => {
    Httpconfig.httptokenget(
      Constant.siteurl + "api/Patients/findpatientrealtives/" + this.state.patientId
    ).then((response) => {
      this.setState({ patientRelatives: response.data.data })
    })
  }

  // Handle change
  handleChange = (name, event) => {

    // Charts
    if (name !== 'All Vitals') {
      $('.Charts').removeClass('collapse-show');
      $('.Charts').addClass('collapse-hide');
      $('#chart_' + name).removeClass('collapse-hide active');
      $('.button').removeClass('active');
      event.currentTarget.className += ' active';
    } else {
      $('.Charts').removeClass('collapse-hide');
      $('.Charts').addClass('collapse-show active');
      $('.button').removeClass('active');
      event.currentTarget.className += ' active';
    }
    this.setState({ name: name })

  }
  // Download Graph as image
  printDiv = () => {
    if (this.state.startdate != "" && this.state.enddate != "" && this.state.patientId != "") {

      if (this.state.name !== 'All Vitals') {
        var divName = 'myChart' + this.state.name;
        var dataUrl = document.getElementById(divName).toDataURL(); //attempt to save base64 string to server using this var  
        const link = document.createElement('a');
        link.download = this.state.name + ".jpeg";
        link.href = dataUrl;
        link.click();
      } else {
        toast.error("We are working on Please wait...");
      }
    } else {
      toast.error("Please select From,To and Family Member");
    }
  }

  // Redirect to View vitals
  redirect = () => {
    window.location.href = Constant.imgurl + "/Viewvitals";
  }




  render() {
    return (
      <main id="main_ord_nav">
        <PatientHeader onSelectLanguage={this.handleLanguage} />
        <section id="order_profile">
          <div className="container" id="main_front">
            <div className="row">
              <div class="col-lg-3 col-md-12">
                <PatientSideMenu />
              </div>
              <div class="col-lg-9 col-md-12">
                <section id="vital_sheet_history">
                  <div class="container">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="vitalsheet_head">
                          <h2 onClick={this.redirect}><img src="../images/patient/img/diagnostics/arrowback.svg"></img>Graphic Chart</h2>
                        </div>
                        <div class="vital_box">
                          <div class="select_mem">
                            <div class="form-group">
                              <label>Select Member*</label>
                              <select
                                onChange={(e) => {
                                  this.state.selectedRelativeId = e.target.value;
                                }}
                                name="slot_time"
                                defaultValue=""
                                className="form-control"
                              >
                                <option value="" disabled={true}>
                                  Select Member
                                </option>
                                {this.state.patientRelatives.map((item) => {
                                  return <option value={item.id} selected={this.state.selectedRelativeId == item.id}>{item.name}</option>;
                                })}
                              </select>
                            </div>
                          </div>
                          <div class="choose_date">
                            <div class="form-group">
                              <label>From*</label>
                              <input type="date" class="form-control"
                                max={moment().format("YYYY-MM-DD")}
                                onChange={(e) => {
                                  this.setState({
                                    selectedSDate: e.currentTarget.value
                                  })

                                }}
                              />
                              {/* <input type="date" class="form-control" /> */}
                            </div>

                          </div>
                          <div class="choose_date">
                            <div class="form-group">
                              <label>To*</label>
                              <input type="date" class="form-control"
                                max={moment().format("YYYY-MM-DD")}
                                onChange={(e) => {
                                  this.setState({
                                    selectedEDate: e.currentTarget.value
                                  })


                                }}
                              />
                              {/* <input type="date" class="form-control" /> */}
                            </div>

                          </div>
                          <div class="vital_submit_btn">
                            <button type="button" onClick={this.getPatientVitals}>Submit</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12">
                        <div className="graphic_buttons">
                          <button className="button" onClick={this.handleChange.bind(this, 'Height')}>Height</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'Weight')}>Weight</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'Bmi')}>BMI</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'Temperature')}>Temperature</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'BloodPressure')}>Blood Pressure</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'Pulse')}>Pulse</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'BloodSugar')}>Blood Sugar</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'RespiratoryRate')}>Respiratory Rate</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'HeartRate')}>Heart Rate</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'HeadCircumference')}>Head circumference</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'Spo2')}>SpO2</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'Steps')}>Steps</button>
                          <button className="button" onClick={this.handleChange.bind(this, 'PainRatingScale')}>Pain Rating Scale</button>
                          <button className="button active" onClick={this.handleChange.bind(this, 'All Vitals')}>All Vitals</button>
                        </div>

                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-12">
                        <div className="graph_chart">
                          {this.state.nodata == "" ?
                            this.state.name !== 'All Vitals' ?
                              <div className="export_button">
                                <button id="download" onClick={this.printDiv}>Download</button>
                              </div>
                              : ""
                            : ""}
                        </div>
                      </div>
                      <div id="VitalGraph">
                        {this.state.nodata ? (<div id="chart_Steps" className="Charts no_data"> {this.state.nodata} </div>) : ""}
                        <div className="row">
                          {/* <div className="col-md-10 vitalchart"> */}
                          <div id="chart_BloodPressure" className="Charts">
                            <canvas
                              id="myChartBloodPressure"
                              ref={this.chartRefBloodPressure}
                            />
                          </div>
                          {/* </div> */}

                          <div id="chart_Height" className="Charts">
                            <canvas
                              id="myChartHeight"
                              ref={this.chartRefHeight}
                            />
                          </div>


                          <div id="chart_Weight" className="Charts">
                            <canvas
                              id="myChartWeight"
                              ref={this.chartRefWeight}
                            />
                          </div>


                          <div id="chart_Bmi" className="Charts">
                            <canvas
                              id="myChartBmi"
                              ref={this.chartRefBmi}
                            />
                          </div>


                          <div id="chart_Temperature" className="Charts">
                            <canvas
                              id="myChartTemperature"
                              ref={this.chartRefTemperature}
                            />
                          </div>


                          <div id="chart_Pulse" className="Charts">
                            <canvas
                              id="myChartPulse"
                              ref={this.chartRefPulse}
                            />
                          </div>


                          <div id="chart_BloodSugar" className="Charts">
                            <canvas
                              id="myChartBloodSugar"
                              ref={this.chartRefBloodSugar}
                            />
                          </div>


                          <div id="chart_RespiratoryRate" className="Charts">
                            <canvas
                              id="myChartRespiratoryRate"
                              ref={this.chartRefRespiratoryRate}
                            />
                          </div>


                          <div id="chart_HeartRate" className="Charts">
                            <canvas
                              id="myChartHeartRate"
                              ref={this.chartRefHeartRate}
                            />
                          </div>


                          <div id="chart_HeadCircumference" className="Charts">
                            <canvas
                              id="myChartHeadCircumference"
                              ref={this.chartRefHeadCircumference}
                            />
                          </div>


                          <div id="chart_Spo2" className="Charts">
                            <canvas
                              id="myChartSpo2"
                              ref={this.chartRefSpo2}
                            />
                          </div>


                          <div id="chart_Steps" className="Charts">
                            <canvas
                              id="myChartSteps"
                              ref={this.chartRefSteps}
                            />
                          </div>


                          <div id="chart_PainRatingScale" className="Charts">
                            <canvas
                              id="myChartPainRatingScale"
                              ref={this.chartRefPainRatingScale}
                            />
                          </div>


                        </div>

                      </div>
                    </div>

                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </main>
    );
  }
}
